const languagePMMap: Record<string, string> = {
  npm: 'typescript',
  nuget: 'csharp',
  maven: 'java',
  pypi: 'python',
  mcp: 'python',
  packagist: 'php',
  ruby: 'ruby',
}

export function getLanguageForPM(packageManager: string, fallback?: string): string | undefined {
  return languagePMMap[packageManager] ?? fallback
}
